import { gql } from '@apollo/client'

export default gql`
    query quoteDetailsForInviteAndMember($id: UUID!, $senderId: Int) {
        quote(id: $id) {
            id
            openEndedQuoteInviteUrl(senderId: $senderId)
            isQuotePurchasable
            user {
                id
                email
                firstName
                lastName
                enabled
            }
            members {
                items {
                    id
                    role
                    user {
                        id
                        displayName
                        firstName
                        lastName
                        email
                        enabled
                    }
                }
            }
            team {
                id
                name
            }
            invites(limit: 100) {
                totalCount
                items {
                    id
                    status
                    email
                    isOpenEnded
                    createdAt
                    deletedAt
                }
            }
        }
    }
`
